import { type FC } from 'react'
import { YouTubeEmbed } from '@next/third-parties/google'
import { YOUTUBE_REGEX } from '.'

type Props =
  | {
      videoId: string
      video?: {
        title: string
        description: string
        uploadDate: string
        duration: string
      }
    }
  | {
      url: string
      video?: {
        title: string
        description: string
        uploadDate: string
        duration: string
      }
    }
const extractYoutubeVideoId = (url: string): string => {
  const match = url.match(YOUTUBE_REGEX)
  return match ? match[1] : ''
}

const extractVideoId = (props: Props): string => {
  if ('videoId' in props) {
    return props.videoId
  }
  return extractYoutubeVideoId(props.url)
}

const generateVideoStructuredData = (videoId: string, props: Props) => {
  const video = 'video' in props ? props.video : undefined

  const structuredData: Record<string, string> = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: video?.title ?? 'YouTube Video',
    description: video?.description ?? '',
    thumbnailUrl: `https://img.youtube.com/vi/${videoId}/0.jpg`,
    contentUrl:
      'url' in props ? props.url : `https://www.youtube.com/watch?v=${videoId}`,
    embedUrl: `https://www.youtube.com/embed/${videoId}`,
  }

  if (video?.uploadDate) {
    structuredData.uploadDate = video.uploadDate
  }

  if (video?.duration) {
    structuredData.duration = video.duration
  }

  return structuredData
}

export const YouTubeVideo: FC<Props> = (props: Props) => {
  const videoId = extractVideoId(props)
  return (
    <>
      <YouTubeEmbed videoid={videoId} />
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(generateVideoStructuredData(videoId, props)),
        }}
      />
    </>
  )
}
